import React, { useState, useEffect } from 'react';

const BusinessInformationTab = () => {
  const [businessInfoData, setBusinessInfoData] = useState({
    
      "business_name": "ADJ Warehouse",
      "email": "contact@techsolutions.com",
      "phone_number": "+1-800-555-1234",
      "trn": "123456789",
      "address": "123 Innovation Drive, Kingston, Jamaica",
      "logo_url": "https://example.com/images/logo.png",
      "auth_logo_url": "https://example.com/images/auth_logo.png",
      "favicon_url": "https://example.com/images/favicon.ico",
      "primary_color": "#1E90FF",
      "secondary_color": "#FFD700"
    
    
  });

  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_BASE_URL;
  const user = JSON.parse(localStorage.getItem('user'));

  const fetchBusinessInfo = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/api/businessInfo/${user.business_id}`);
      const data = await response.json();
      setBusinessInfoData(data);
    } catch (err) {
      console.error('Error fetching business info:', err);
      setError('Failed to load business info.');
    } finally {
      setLoading(false);
    }
  };

  // Fetch business info when the component loads
  useEffect(() => {
    

    // fetchBusinessInfo();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBusinessInfoData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
  
    try {
          await fetch(`${apiUrl}/api/businessInfo/${user.business_id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(businessInfoData ),
          });
          console.log(businessInfoData);
  
      setEditMode(false);
    } catch (err) {
      console.error('Error updating business info:', err);
      setError('Failed to save changes. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleCancel = () => {
    setEditMode(false);
    setError(null);
  };

  if (loading) {
    return <p>Loading business information...</p>;
  }

  if (error) {
    return <p className="text-red-500">{error}</p>;
  }

  return (
    <div>
      <h2 className="text-xl">Business Information</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-control w-full">
          <label className="label">
            <span className="label-text">Business Name</span>
          </label>
          {editMode ? (
            <input
              type="text"
              name="business_name"
              value={businessInfoData.business_name}
              onChange={handleInputChange}
              className="input input-bordered w-full bg-gray-50"
              required
              placeholder="Business Name"
            />
          ) : (
            <p>{businessInfoData.business_name}</p>
          )}
        </div>

        <div className="flex gap-4">
          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">Email Address</span>
            </label>
            {editMode ? (
              <input
                type="email"
                name="email"
                value={businessInfoData.email}
                onChange={handleInputChange}
                className="input input-bordered w-full bg-gray-50"
                required
                placeholder="Email Address"
              />
            ) : (
              <p>{businessInfoData.email}</p>
            )}
          </div>
          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">Phone Number</span>
            </label>
            {editMode ? (
              <input
                type="text"
                name="phone_number"
                value={businessInfoData.phone_number}
                onChange={handleInputChange}
                className="input input-bordered w-full bg-gray-50"
                required
                placeholder="Phone Number"
              />
            ) : (
              <p>{businessInfoData.phone_number}</p>
            )}
          </div>
        </div>

        <div className="form-control w-full">
          <label className="label">
            <span className="label-text">TRN</span>
          </label>
          {editMode ? (
            <input
              type="text"
              name="trn"
              value={businessInfoData.trn}
              onChange={handleInputChange}
              className="input input-bordered w-full bg-gray-50"
              required
              placeholder="TRN"
            />
          ) : (
            <p>{businessInfoData.trn}</p>
          )}
          <p>Used for ASYCUDA XML generation, invoices, and payment receipts</p>
        </div>

        <div className="form-control w-full">
          <label className="label">
            <span className="label-text">Address</span>
          </label>
          {editMode ? (
            <textarea
              name="address"
              value={businessInfoData.address}
              onChange={handleInputChange}
              className="textarea textarea-bordered w-full bg-gray-50"
              required
              placeholder="Address"
            />
          ) : (
            <p>{businessInfoData.address}</p>
          )}
        </div>

        {editMode ? (
          <div className="flex gap-x-4 p-4 justify-end">
            <button type="button" onClick={handleCancel} className="btn btn-outline">
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save Changes
            </button>
          </div>
        ) : (
          <div className="flex gap-x-4 p-4 justify-end">
            <button type="button" onClick={handleEdit} className="btn btn-primary">
              Edit
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default BusinessInformationTab;
